import { SvgProps } from './ic_portfolio';

export function IconOrder(props: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={25}
            height={24}
            fill="none"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.902 19.5H4.695a.75.75 0 0 0 0 1.5h15.207a.75.75 0 0 0 0-1.5ZM4.695 4.5h15.207a.75.75 0 0 0 0-1.5H4.695a.75.75 0 0 0 0 1.5ZM17.704 5.82H6.896c-2 0-3.628 1.628-3.628 3.63v5.073a3.633 3.633 0 0 0 3.628 3.63h10.809a3.633 3.633 0 0 0 3.629-3.63V9.45a3.633 3.633 0 0 0-3.63-3.629Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

export function IconFeed(props: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.302 11.658L11.494 14.938C11.211 15.182 10.791 15.18 10.51 14.933L8.406 13.083L5.519 15.222C5.385 15.322 5.228 15.37 5.073 15.37C4.844 15.37 4.617 15.265 4.47 15.066C4.223 14.733 4.293 14.263 4.626 14.017L8 11.517C8.284 11.306 8.677 11.324 8.942 11.556L11.01 13.376L14.323 10.521C14.636 10.252 15.11 10.284 15.381 10.6C15.652 10.914 15.616 11.387 15.302 11.658ZM3.44 8.09C3.44 7.676 3.776 7.34 4.19 7.34H8.135C8.549 7.34 8.885 7.676 8.885 8.09C8.885 8.504 8.549 8.84 8.135 8.84H4.19C3.776 8.84 3.44 8.504 3.44 8.09ZM4.19 4.34H6.673C7.087 4.34 7.423 4.676 7.423 5.09C7.423 5.504 7.087 5.84 6.673 5.84H4.19C3.776 5.84 3.44 5.504 3.44 5.09C3.44 4.676 3.776 4.34 4.19 4.34ZM13.034 3.78C14.366 3.78 15.45 4.861 15.45 6.189C15.45 7.524 14.366 8.61 13.034 8.61C11.702 8.61 10.619 7.524 10.619 6.189C10.619 4.861 11.702 3.78 13.034 3.78ZM13.718 0H5.283C2.123 0 0 2.222 0 5.53V13.47C0 16.777 2.123 19 5.283 19H13.717C16.877 19 19 16.777 19 13.47V5.53C19 2.222 16.877 0 13.718 0Z"
                fill="white"
            />
        </svg>
    );
}
